import { Schedule } from '@/features/accounts/types';
import ScheduleStatusLabel from '@/features/accounts/schedule/components/ScheduleStatusLabel';
import ApplicationStateLabel from '@/features/accounts/schedule/components/ApplicationStateLabel';

interface Props {
  schedule: Schedule | null;
}

export default function StatusCell({ schedule }: Props) {
  if (!schedule) return null;

  return (
    <>
      <span className="text-sm text-slate-600">
        <ScheduleStatusLabel status={schedule.status} />
      </span>
      {!schedule.bookable && <ApplicationStateLabel schedule={schedule} />}
    </>
  );
}
